const isTouchDevice = () => {
  return navigator.maxTouchPoints || "ontouchstart" in document.documentElement;
};

export default isTouchDevice;
